<template>
    <!--About Four Start-->
    <section class="about-four">
            <!-- About US Start -->
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 ">
                        <div class="about-four__left">
                            <div class="about-four__img-box">
                                <!--Primera Imagen -->
                                <div class="about-four__img">
                                    <!-- <img src="assets/images/resources/about-four-img-1.jpg" alt=""> -->
                                    <img src="assets/images/about/maquina.jpg" alt="">
                                </div>

                                <!--Segunda Imagen -->
                                <!-- <div class="about-four__img-two">
                                    <img src="assets/images/about/panel.jpg" alt="">
                                    <img src="assets/images/resources/about-four-img-2.jpg" alt="">
                                </div> -->
                                <div class="about-four__border"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6">
                        <div class="about-four__right">
                            <div class="section-title text-left">
                                <!-- <span class="section-title__tagline">Acerca de IEH Control</span>s  -->
                                <h2 class="section-title__title">Acerca de Nosotros</h2>
                            </div>
                            <!-- <p>class="about-four__text"</p> -->
                            <p  style="text-align: justify;">En Ingeniería Eléctrica e Hidráulica (IEH), 
                                somos una empresa especializada en brindar servicios de mantención eléctrica
                                 e hidráulica de alta calidad. Contamos con un equipo técnico altamente 
                                 capacitado y la maquinaria necesaria para ofrecer soluciones integrales y eficientes
                                 , adaptadas a las necesidades de cada cliente.
                            <br>Nuestro compromiso es ofrecer un servicio personalizado, confiable y de 
                            excelencia, superando siempre las expectativas de nuestros clientes. Actualmente, 
                            estamos innovando en tecnologías avanzadas como telemetría, automatización e IoT
                            , con el objetivo de apoyar a nuestros clientes en la optimización de sus procesos industriales. 
                            Algunos ejemplos de nuestras soluciones incluyen la monitorización y control de sistemas de riego
                             tecnificado, bombas de pozo profundo, y más, siempre en cumplimiento con la Ley N° 1238 promulgada
                              por la DGA.
                            </p>
                            
                        </div>
                    </div>
                </div>
                
            </div>
            <!-- About US END -->
           
        </section>
        <!--About Four End-->
        <br>
        <br>
        
</template>
    <style>
        @media only screen and (max-width: 1024px){
            .about-four__right {
                margin: 1px auto 0;
            }
            .section-title__title {
                margin-top: 0px;
            }
        }

        @media only screen and (max-width: 768px){
            .about-four {
                padding: 80px 0 0;
            }
            .section-title__title {
                margin-top: 30px;
            }

            .about-four__right {
                max-width: 664px;
            }
            .about-four__text {
                margin-right: 10px;
                margin-left: 10px;
            }
        }

    </style>
<script>
</script>